import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";
import Auth from "../modules/auth/Auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home",
        name: "Home",
        meta: { title: "Início", requiresAuth: true },
        component: () => import("@/modules/main/views/home/Home.vue"),
      },
      {
        path: "users",
        name: "Users",
        redirect: { name: "UsersList" },
        component: () => import("@/modules/main/views/users/Users.vue"),
        children: [
          {
            path: "",
            name: "UsersList",
            meta: { title: "Usuários", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/users/children/usersList/UsersList.vue"
              ),
          },
          {
            path: ":id",
            name: "UserProfile",
            meta: { title: "Perfil do Usuário", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/users/children/userProfile/UserProfile.vue"
              ),
          },
        ],
      },
      {
        path: "moves",
        name: "Moves",
        meta: { title: "Movimentações financeiras", requiresAuth: true },
        component: () => import("@/modules/main/views/moves/Moves.vue"),
      },
      {
        path: "withdraws",
        name: "Withdraws",
        meta: { title: "Solicitações de saque", requiresAuth: true },
        component: () => import("@/modules/main/views/withdraws/Withdraws.vue"),
      },
      {
        path: "deposits",
        name: "Deposits",
        meta: { title: "Depósitos", requiresAuth: true },
        component: () => import("@/modules/main/views/deposits/Deposits.vue"),
      },
      {
        path: "sms",
        name: "SMS",
        meta: { title: "Envio de SMS", requiresAuth: true },
        component: () => import("@/modules/main/views/sms/Sms.vue"),
      },
      {
        path: "email",
        name: "Email",
        meta: { title: "Envio de E-mail", requiresAuth: true },
        component: () => import("@/modules/main/views/email/Email.vue"),
      },
      {
        path: "prize-word",
        name: "PrizeWord",
        meta: { title: "Palavra Premiada", requiresAuth: true },
        component: () => import("@/modules/main/views/prizeWord/PrizeWord.vue"),
      },
      {
        path: "hangman",
        name: "Hangman",
        meta: { title: "Jogo da forca", requiresAuth: true },
        component: () => import("@/modules/main/views/hangman/Hangman.vue"),
      },
      {
        path: "raffles",
        name: "Raffles",
        meta: { title: "Sorteios", requiresAuth: true },
        redirect: { name: "RafflesList" },
        component: () => import("@/modules/main/views/raffles/Raffles.vue"),
        children: [
          {
            path: "",
            name: "RafflesList",
            meta: { title: "Usuários", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/raffles/children/rafflesList/RafflesList.vue"
              ),
          },
          {
            path: ":id",
            name: "RaffleDetails",
            meta: { title: "Detalhes do sorteio", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/raffles/children/raffleDetails/RaffleDetails.vue"
              ),
          },
        ],
      },
      {
        path: "sponsor",
        name: "Sponsor",
        meta: { title: "Patrocinador", requiresAuth: true },
        component: () => import("@/modules/main/views/sponsor/Sponsor.vue"),
        children: [
          {
            path: "dashboard",
            name: "DashboardSponsor",
            meta: { title: "Dashboard de públicidade", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/dashboard/Dashboard.vue"
              ),
          },
          {
            path: "campaigns",
            name: "CampaignsSponsor",
            meta: { title: "Campanhas", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/campaigns/Campaigns.vue"
              ),
          },
          {
            path: "reports",
            name: "ReportsSponsor",
            meta: { title: "Relatórios de públicidade", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/reports/Reports.vue"
              ),
          },
        ],
      },
      {
        path: "affiliates",
        name: "Affiliates",
        redirect: { name: "AffiliatesList" },
        component: () =>
          import("@/modules/main/views/affiliates/Affiliates.vue"),
        children: [
          {
            path: "",
            name: "AffiliatesList",
            meta: { title: "Afiliados", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/affiliates/children/affiliatesList/AffiliatesList.vue"
              ),
          },
          {
            path: "dashboard",
            name: "DashboardAffiliates",
            meta: { title: "Dashboard de afiliados", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/affiliates/children/dashboard/Dashboard.vue"
              ),
          },
          {
            path: "reports",
            name: "ReportsAffiliates",
            meta: { title: "Relatórios de afiliados", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/affiliates/children/reports/Reports.vue"
              ),
          },
        ],
      },
      {
        path: "shipments",
        name: "Shipments",
        meta: { title: "Remessas", requiresAuth: true },
        component: () => import("@/modules/main/views/shipments/Shipments.vue"),
      },
      {
        path: "wheels",
        name: "Wheels",
        meta: { title: "Roletas", requiresAuth: true },
        component: () => import("@/modules/main/views/wheels/Wheels.vue"),
      },
      {
        path: "draws",
        name: "Draws",
        redirect: {
          name: "Scratches",
        },
        meta: { requiresAuth: true },
        component: () => import("@/modules/main/views/draws/Draws.vue"),
        children: [
          {
            path: "scratches",
            name: "Scratches",
            meta: { title: "Raspadinhas", requiresAuth: true },
            component: () =>
              import("@/modules/main/views/draws/children/games/Games.vue"),
          },
          {
            path: "boxes",
            name: "Boxes",
            meta: { title: "Caixas", requiresAuth: true },
            component: () =>
              import("@/modules/main/views/draws/children/games/Games.vue"),
          },
          {
            path: "pots",
            name: "Pots",
            meta: { title: "Potes", requiresAuth: true },
            component: () =>
              import("@/modules/main/views/draws/children/pots/Pots.vue"),
          },
          {
            path: "pot-groups",
            name: "PotGroups",
            meta: { title: "Grupos de Potes", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/draws/children/potGroups/PotGroups.vue"
              ),
          },
        ],
      },
      {
        path: "promotions",
        name: "Promotions",
        meta: { title: "Promoções", requiresAuth: true },
        component: () =>
          import("@/modules/main/views/promotions/Promotions.vue"),
      },
      {
        path: "milestones",
        name: "Milestones",
        meta: { title: "Trilha de recompensas", requiresAuth: true },
        component: () =>
          import("@/modules/main/views/milestones/Milestones.vue"),
      },
      {
        path: "store",
        name: "Store",
        meta: { title: "Gerenciar Items", requiresAuth: true },
        component: () => import("@/modules/main/views/store/Store.vue"),
      },
      {
        path: "banners",
        name: "Banners",
        meta: { title: "Gerenciar Banners", requiresAuth: true },
        component: () => import("@/modules/main/views/banners/Banners.vue"),
      },
      {
        path: "settings",
        name: "Settings",
        meta: { title: "Definições da plataforma", requiresAuth: true },
        component: () => import("@/modules/main/views/settings/Settings.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "SignIn" },
    component: Auth,
    children: [
      {
        path: "sign-in",
        name: "SignIn",
        meta: { title: "Entrar", preventAuth: true },
        component: () => import("@/modules/auth/views/signIn/SignIn.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
